export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const SORT_USERS = 'SORT_USERS';

export const INIT_ADMINS_SEARCH_PARAMS = 'INIT_ADMINS_SEARCH_PARAMS';
export const FETCH_ADMINS = 'FETCH_ADMINS';
export const FETCH_ADMINS_SUCCESS = 'FETCH_ADMINS_SUCCESS';
export const FETCH_ADMINS_FAILURE = 'FETCH_ADMINS_FAILURE';

export const INIT_PURGED_SEARCH_PARAMS = 'INIT_PURGED_SEARCH_PARAMS';
export const FETCH_PURGED_USER = 'FETCH_PURGED_USER';
export const FETCH_PURGED_USER_SUCCESS = 'FETCH_PURGED_USER_SUCCESS';
export const FETCH_PURGED_USER_FAILURE = 'FETCH_PURGED_USER_FAILURE';

export const FETCH_PURGED_USERS = 'FETCH_PURGED_USERS';
export const FETCH_PURGED_USERS_SUCCESS = 'FETCH_PURGED_USERS_SUCCESS';
export const FETCH_PURGED_USERS_FAILURE = 'FETCH_PURGED_USERS_FAILURE';

export const FETCH_AUDIT_TRAIL = 'FETCH_AUDIT_TRAIL';
export const FETCH_AUDIT_TRAIL_SUCCESS = 'FETCH_AUDIT_TRAIL_SUCCESS';
export const FETCH_AUDIT_TRAIL_FAILURE = 'FETCH_AUDIT_TRAIL_FAILURE';

export const RESET_AUDIT_TRAIL_PAGINATION = 'RESET_AUDIT_TRAIL_PAGINATION';

export const SAVE_AUDIT_TRAIL_COMMENT = 'SAVE_AUDIT_TRAIL_COMMENT';
export const SAVE_AUDIT_TRAIL_COMMENT_SUCCESS = 'SAVE_AUDIT_TRAIL_COMMENT_SUCCESS';
export const SAVE_AUDIT_TRAIL_COMMENT_FAILURE = 'SAVE_AUDIT_TRAIL_COMMENT_FAILURE';

export const UPDATE_USER_DISPLAY = 'UPDATE_USER_DISPLAY';

export const SAVE_CREDENTIALS = 'SAVE_CREDENTIALS';
export const PURGE_TOKENS = 'PURGE_TOKENS';

export const NYL_ADMIN_ACCESS_TOKEN = 'NYL_ADMIN_ACCESS_TOKEN';
export const NYL_ADMIN_REFRESH_TOKEN = 'NYL_ADMIN_REFRESH_TOKEN';
export const NYL_ADMIN_IDENTITY_TOKEN = 'NYL_ADMIN_IDENTITY_TOKEN';
export const NYL_ADMIN_IDENTITY = 'NYL_ADMIN_IDENTITY';
export const NYL_ADMIN_EXPIRES_IN = 'NYL_ADMIN_EXPIRES_IN';

export const INIT_SEARCH_PARAMS = 'INIT_SEARCH_PARAMS';

export const FETCH_FEATURES_SETTINGS = 'FETCH_FEATURES_SETTINGS';
export const FETCH_FEATURES_SETTINGS_SUCCESS = 'FETCH_FEATURES_SETTINGS_SUCCESS';
export const FETCH_FEATURES_SETTINGS_FAILURE = 'FETCH_FEATURES_SETTINGS_FAILURE';

export const FETCH_FEATURES_AUDIT_TRAIL = 'FETCH_FEATURES_AUDIT_TRAIL';
export const FETCH_FEATURES_AUDIT_TRAIL_SUCCESS = 'FETCH_FEATURES_AUDIT_TRAIL_SUCCESS';
export const FETCH_FEATURES_AUDIT_TRAIL_FAILURE = 'FETCH_FEATURES_AUDIT_TRAIL_FAILURE';
export const RESET_FEATURES_AUDIT_TRAIL_PAGINATION = 'RESET_FEATURES_AUDIT_TRAIL_PAGINATION';

export const SET_TICKETSCAN_LIMIT = 'SET_TICKETSCAN_LIMIT';

export const SET_IS_BULK_USER_WORKFLOW = 'SET_IS_BULK_USER_WORKFLOW';
export const SET_IS_SINGLE_USER_WORKFLOW = 'SET_IS_SINGLE_USER_WORKFLOW';
export const SET_IS_FEATURES_WORKFLOW = 'SET_IS_FEATURES_WORKFLOW';

export const SELECT_USER_FOR_BULK = 'SELECT_USER_FOR_BULK';
export const DESELECT_USER_FOR_BULK = 'DESELECT_USER_FOR_BULK';
export const START_BULK_ACTION_WORKFLOW = 'START_BULK_ACTION_WORKFLOW';
export const ADD_COMMENT = 'ADD_COMMENT';
export const CANCEL_BULK_ACTION_WORKFLOW = 'CANCEL_BULK_ACTION_WORKFLOW';
export const FINISH_BULK_ACTION_WORKFLOW = 'FINISH_BULK_ACTION_WORKFLOW';
export const PERFORM_BULK_ACTION = 'PERFORM_BULK_ACTION';
export const PERFORM_BULK_ACTION_SUCCESS = 'PERFORM_BULK_ACTION_SUCCESS';
export const PERFORM_BULK_ACTION_FAILURE = 'PERFORM_BULK_ACTION_FAILURE';

export const START_UPDATE_USER_MODAL_WORKFLOW = 'START_UPDATE_USER_MODAL_WORKFLOW';
export const START_SINGLE_ACTION_WORKFLOW = 'START_SINGLE_ACTION_WORKFLOW';
export const ADD_SINGLE_COMMENT = 'ADD_SINGLE_COMMENT';
export const CANCEL_SINGLE_ACTION_WORKFLOW = 'CANCEL_SINGLE_ACTION_WORKFLOW';
export const PERFORM_SINGLE_ACTION = 'PERFORM_SINGLE_ACTION';
export const PERFORM_SINGLE_ACTION_SUCCESS = 'PERFORM_SINGLE_ACTION_SUCCESS';
export const PERFORM_SINGLE_ACTION_FAILURE = 'PERFORM_SINGLE_ACTION_FAILURE';
export const FINISH_SINGLE_ACTION_WORKFLOW = 'FINISH_SINGLE_ACTION_WORKFLOW';
export const USERS_TABLE_LIMIT = 10;

export const START_FEATURES_WORKFLOW = 'START_FEATURES_WORKFLOW';
export const ADD_FEATURES_COMMENT = 'ADD_FEATURES_COMMENT';
export const ADD_PARAMETERS = 'ADD_PARAMETERS';
export const CANCEL_FEATURES_WORKFLOW = 'CANCEL_FEATURES_WORKFLOW';
export const PERFORM_FEATURES_ACTION = 'PERFORM_FEATURES_ACTION';
export const PERFORM_FEATURES_ACTION_SUCCESS = 'PERFORM_FEATURES_ACTION_SUCCESS';
export const PERFORM_FEATURES_ACTION_FAILURE = 'PERFORM_FEATURES_ACTION_FAILURE';
export const FINISH_FEATURES_WORKFLOW = 'FINISH_FEATURES_WORKFLOW';

export const SAVE_FEATURE_AUDIT_TRAIL_COMMENT = 'SAVE_FEATURE_AUDIT_TRAIL_COMMENT';
export const SAVE_FEATURE_AUDIT_TRAIL_COMMENT_SUCCESS = 'SAVE_FEATURE_AUDIT_TRAIL_COMMENT_SUCCESS';
export const SAVE_FEATURE_AUDIT_TRAIL_COMMENT_FAILURE = 'SAVE_FEATURE_AUDIT_TRAIL_COMMENT_FAILURE';

export const START_TICKETSCAN_TOGGLE_FLOW = 'START_TICKETSCAN_TOGGLE_FLOW';
export const START_TICKETSCAN_LIMIT_FLOW = 'START_TICKETSCAN_LIMIT_FLOW';
export const START_SPIN_TO_WIN_LIMIT_FLOW = 'START_SPIN_TO_WIN_LIMIT_FLOW';

export const START_INVITE_ADMIN_FLOW = 'START_INVITE_ADMIN_FLOW';
export const INVITE_ADMIN_SUCCESS = 'INVITE_ADMIN_SUCCESS';
export const INVITE_ADMIN_FAILURE = 'INVITE_ADMIN_FAILURE';

export const START_EDIT_ADMIN_FLOW = 'START_EDIT_ADMIN_FLOW';
export const EDIT_ADMIN_SUCCESS = 'EDIT_ADMIN_SUCCESS';
export const EDIT_ADMIN_FAILURE = 'EDIT_ADMIN_FAILURE';

export const START_TOGGLE_ADMIN_FLOW = 'START_TOGGLE_ADMIN_FLOW';
export const LOCK_ADMIN_SUCCESS = 'LOCK_ADMIN_SUCCESS';
export const LOCK_ADMIN_FAILURE = 'LOCK_ADMIN_FAILURE';
export const UNLOCK_ADMIN_SUCCESS = 'UNLOCK_ADMIN_SUCCESS';
export const UNLOCK_ADMIN_FAILURE = 'UNLOCK_ADMIN_FAILURE';

export const PERFORM_ADMINS_ACTION = 'PERFORM_ADMINS_ACTION';

export const FINISH_ADMINS_WORKFLOW = 'FINISH_ADMINS_WORKFLOW';
export const CANCEL_ADMINS_WORKFLOW = 'CANCEL_ADMINS_WORKFLOW';

export const ADD_ADMINS_COMMENT = 'ADD_ADMINS_COMMENT';
export const ADD_ADMIN_DETAILS = 'ADD_ADMIN_DETAILS';

export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';

export const CREATE_EVENT = 'CREATE_EVENT';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILURE = 'CREATE_EVENT_FAILURE';
export const CREATE_EVENT_RESET = 'CREATE_EVENT_RESET';

export const FETCH_GAMES_FOR_EVENTS = 'FETCH_GAMES_FOR_EVENTS';
export const FETCH_GAMES_FOR_EVENTS_SUCCESS = 'FETCH_GAMES_FOR_EVENTS_SUCCESS';
export const FETCH_GAMES_FOR_EVENTS_FAILURE = 'FETCH_GAMES_FOR_EVENTS_FAILURE';
export const GAMES_FOR_EVENTS_RESET = 'FETCH_GAMES_FOR_EVENTS_RESET';

export const FETCH_SINGLE_EVENT = 'FETCH_SINGLE_EVENT';
export const FETCH_SINGLE_EVENT_SUCCESS = 'FETCH_SINGLE_EVENT_SUCCESS';
export const FETCH_SINGLE_EVENT_FAILURE = 'FETCH_SINGLE_EVENT_FAILURE';
export const SINGLE_EVENT_RESET = 'SINGLE_EVENT_RESET';

export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'UPDATE_EVENT_FAILURE';
export const UPDATE_EVENT_RESET = 'UPDATE_EVENT_RESET';

export const FETCH_EVENT_AUDIT_LOGS = 'FETCH_EVENT_AUDIT_LOGS';
export const FETCH_EVENT_AUDIT_LOGS_SUCCESS = 'FETCH_EVENT_AUDIT_LOGS_SUCCESS';
export const FETCH_EVENT_AUDIT_LOGS_FAILURE = 'FETCH_EVENT_AUDIT_LOGS_FAILURE';
export const EVENT_AUDIT_LOG_RESET = 'EVENT_AUDIT_LOG_RESET';

export const FETCH_EVENT_HISTORY = 'FETCH_EVENT_HISTORY';
export const FETCH_EVENT_HISTORY_SUCCESS = 'FETCH_EVENT_HISTORY_SUCCESS';
export const FETCH_EVENT_HISTORY_FAILURE = 'FETCH_EVENT_HISTORY_FAILURE';
export const RESET_EVENT_LOG = 'RESET_EVENT_LOG';

export const MARK_EVENT_FOR_DELETION = 'MARK_EVENT_FOR_DELETION';
export const MARK_EVENT_FOR_DELETION_SUCCESS = 'MARK_EVENT_FOR_DELETION_SUCCESS ';
export const MARK_EVENT_FOR_DELETION_FAILURE = 'MARK_EVENT_FOR_DELETION_FAILURE ';

export const FETCH_LOYALTY_USER = 'FETCH_LOYALTY_USER';
export const FETCH_LOYALTY_USER_SUCCESS = 'FETCH_LOYALTY_USER_SUCCESS';
export const FETCH_LOYALTY_USER_FAILURE = 'FETCH_LOYALTY_USER_FAILURE';
export const RESET_LOYALTY_USER = 'RESET_LOYALTY_USER';

export const FETCH_SPIN_TO_WIN_SETTINGS = 'FETCH_SPIN_TO_WIN_SETTINGS';
export const FETCH_SPIN_TO_WIN_SETTINGS_SUCCESS = 'FETCH_SPIN_TO_WIN_SETTINGS_SUCCESS';
export const FETCH_SPIN_TO_WIN_SETTINGS_FAILURE = 'FETCH_SPIN_TO_WIN_SETTINGS_FAILURE';
